export const getDoctorHolidayList = (store) => store.doctorHoliday.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.doctorHoliday;
  return rest;
};
export const getDoctorList = (store) => store.doctorHoliday.filters.doctor;
export const getLeaveList = (store) => store.doctorHoliday.filters.leave;
